// extracted by mini-css-extract-plugin
module.exports = {"modal":"QrCodeButton_modal__N7qQZ","button":"QrCodeButton_button__dLGBh","large":"QrCodeButton_large__ODu3w"};